export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://clouddev2api.i95-dev.com/api/'

export const COGNITO_CONFIG = {
    region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
    userPoolId: process.env.REACT_APP_AWS_USERPOOLID || 'us-east-1_Ox4Vg6Tz0',
    userPoolWebClientId: process.env.REACT_APP_AWS_CLIENTID || '21osdv823olqsgs6ukbgkjleki',
    oauthDomain: process.env.REACT_APP_AWS_OAUTH_DOMAIN || 'cloud-dev.auth.us-east-1.amazoncognito.com'
}
